import React from "react";
import {
  DataText,
  Info,
  InputLabelContainer,
  LabelText,
  ValueText
} from "./styles";
import * as IconMui from "@mui/icons-material";
import theme from "@/styles/theme";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import TrendingDownOutlinedIcon from "@mui/icons-material/TrendingDownOutlined";
import TrendingFlatOutlinedIcon from "@mui/icons-material/TrendingFlatOutlined";

interface IInputWithIcon {
  label: string;
  value: number | string;
  icon: keyof typeof IconMui;
  percentage: number;
  formating?: "currency" | "percent" | "decimal" | "unit";
  hidePercentage?: boolean;
}

export const DataCard: React.FC<IInputWithIcon> = ({
  label,
  value,
  icon,
  percentage,
  formating = "decimal",
  hidePercentage = false
}) => {
  const Icon = IconMui[icon];

  const isPositive = percentage > 0;
  const isNegative = percentage < 0;

  const ChangeIcon = isPositive
    ? TrendingUpOutlinedIcon
    : isNegative
    ? TrendingDownOutlinedIcon
    : TrendingFlatOutlinedIcon;

  const changeColor = isPositive
    ? theme.colors.palete.green
    : isNegative
    ? theme.colors.palete.red
    : "#FFFFFF";

  return (
    <InputLabelContainer>
      <Icon
        component="svg"
        sx={{
          color: theme.colors.palete.gold,
          margin: 1,
          fontSize: "27px"
        }}
      />
      <div className="column">
        <LabelText>{label}</LabelText>
        <Info>
          <ValueText>
            {value.toLocaleString("pt-BR", {
              style: formating,
              currency: "BRL",
              maximumFractionDigits: 2
            })}
          </ValueText>
          {!hidePercentage && (
            <div
              className="couting"
              style={{
                color: changeColor
              }}
            >
              <ChangeIcon
                sx={{ fontSize: theme.fontSize.md2, marginBottom: "5px" }}
              />
              <DataText>{percentage}%</DataText>
            </div>
          )}
        </Info>
      </div>
    </InputLabelContainer>
  );
};
